const riasecVariants = {
  enterprising: {
    strong_suit: "Liderski",
    variants: [
      {
        top1: "Chętnie bierzesz odpowiedzialność za wykonywane zadania i osoby współpracujące z Tobą.",
        top2: "Wykazujesz się wysoką multizadaniowością i umiejetnością przejmownia kontroli nad przebiegiem spraw.",
        top3: "Łatwo interpretujesz dane numeryczne wykorzystując je do podejmowania decyzji często o podwyższonym stopniu ryzyka.",
        demotivation:
          "Brak decyzyjności, wpływu na organizację lub większego celu poprzez swoją pracę wpływa na Ciebie silnie demotywująco.",
        motivation:
          "Potrzebujesz częstego docenienia swoich wysiłków, możliwości organizowania własnej pracy, a także konkurencji i ambitnych wyzwań.",
        boss: "Demotywują Cię niezorganizowani szefowie przydzielający Ci proste, mechaniczne zadania.",
      },
      {
        top1: "Naturalnie przejmujesz odpowiedzialność za realizację celów oraz koordynację pracy innych.",
        top2: "Sprawnie działasz w kilku obszarach jednocześnie i potrafisz przejąć ster, gdy sytuacja tego wymaga.",
        top3: "Analizujesz liczby i dane w sposób praktyczny, wykorzystując je do podejmowania odważnych decyzji.",
        demotivation:
          "Brak realnego wpływu, przeciągające się decyzje i praca pozbawiona sensu strategicznego, to coś co Cię demotywuje.",
        motivation:
          "Motywują Cię ambitne cele, możliwość samodzielnego planowania działań oraz docenienie efektów Twojej pracy.",
        boss: "Najlepiej funkcjonujesz z liderem, który ufa kompetencjom zespołu i nie ogranicza Cię do rutynowych zadań.",
      },
      {
        top1: "Czujesz się najlepiej, gdy możesz brać odpowiedzialność za ludzi, decyzje i wynik.",
        top2: "Potrafisz ogarniać wiele tematów naraz i szybko reagować, gdy sytuacja wymaga przejęcia kontroli.",
        top3: "Liczby traktujesz jak narzędzie – pomagają Ci podejmować decyzje, nawet gdy wiążą się z ryzykiem.",
        demotivation:
          "Demotywuje Cię chaotyczne środowisko, brak decyzyjności i praca, w której nie masz wpływu na kierunek działań.",
        motivation:
          "Motywuje Cię rywalizacja, wyzwania, autonomia i jasny sygnał, że Twoje zaangażowanie ma znaczenie.",
        boss: "Potrzebujesz przełożonego, który stawia na odpowiedzialność, a nie na mikrozarządzanie.",
      },
      {
        top1: "Bierzesz odpowiedzialność nie tylko za realizację zadań, ale także za osoby, z którymi współpracujesz.",
        top2: "Dobrze odnajdujesz się w środowiskach wymagających działania na wielu frontach jednocześnie.",
        top3: "Sprawnie interpretujesz dane liczbowe i wykorzystujesz je do podejmowania decyzji.",
        demotivation:
          "Najbardziej zniechęca Cię brak decyzyjności, ograniczony wpływ na organizację.",
        motivation:
          "Do działania napędzają Cię ambitne wyzwania, możliwość samodzielnego organizowania swojej pracy oraz regularne docenianie efektów.",
        boss: "Najlepiej pracujesz z przełożonym, który stawia na zaufanie, a nie kontrolę.",
      },
      {
        top1: "Bierzesz odpowiedzialność i potrafisz prowadzić innych do celu.",
        top2: "Działasz wielotorowo i przejmujesz kontrolę, gdy sytuacja tego wymaga.",
        top3: "Wykorzystujesz liczby do podejmowania szybkich i trafnych decyzji.",
        demotivation:
          "Brak wpływu, jasnych decyzji i sensu w działaniach wpływa na Ciebie silnie demotywująco.",
        motivation:
          "Wyzwania, autonomia, zdrowa rywalizacja i uznanie za efekty motywują Cię.",
        boss: "Szukasz szefa takiego, który ufa i nie ogranicza Cię do powtarzalnych zadań.",
      },
      {
        top1: "Skutecznie przejmujesz odpowiedzialność za projekty oraz zespoły.",
        top2: "Wysoka odporność na presję i umiejętność równoległego zarządzania wieloma obszarami.",
        top3: "Podejmujesz decyzje w oparciu o analizę danych, także w sytuacjach podwyższonego ryzyka.",
        demotivation:
          "Niejasna struktura decyzyjna oraz ograniczony wpływ na strategię organizacji demotywują Cię.",
        motivation:
          "Motywują Cię Ambitne cele, swoboda działania i regularne uznanie wyników Twojej pracy.",
        boss: "Preferujesz liderów z wizją, którzy unikają chaosu i delegują odpowiedzialne zadania.",
      },
      {
        top1: "Naturalnie przejmujesz rolę osoby decyzyjnej i odpowiedzialnej za wynik.",
        top2: "Potrafisz jednocześnie prowadzić kilka wątków i pilnować kierunku działań.",
        top3: "Sprawnie korzystasz z danych, by podejmować odważne, ale przemyślane decyzje.",
        demotivation:
          "Brak sprawczości, opóźnianie decyzji i praca bez realnego celu demotywują Cię.",
        motivation:
          "Motywują Cię Wyzwania, możliwość decydowania, zdrowa konkurencja i zauważenie Twojego wkład.",
        boss: "Najlepiej pracujesz z przełożonym, który stawia na zaufanie, a nie kontrolę.",
      },
    ],
    desc: "inicjatywa i umiejętność przewodzenia",
    cv_entry:
      "Zaproponowałem i przeprowadziłem dwudniowy program onboardingowy dla 3 stażystów Jobbli, skutkujący podwyższeniem satysfakcji pracowników o 17%.",
  },
  realistic: {
    strong_suit: "Techniczny",
    variants: [
      {
        top1: "Dzięki zainteresowaniu zasadami działania oraz budową obiektów masz zdolność do naprawiania i wytwarzania przedmiotów.",
        top2: "Łatwo implementujesz nauczone schematy i wyobrażasz sobie przedmioty w 3D.",
        top3: "Wyróżniasz się zdolnością logicznego myślenia, metodycznie rozwijązujesz problemy analizując wszystkie możliwe informacje i fakty.",
        demotivation:
          "Niejasne zasady pracy, brak orientacji na jakość i precyzję wykonywanych zadań ogranicza Twoje możliwości wykazania swoich mocnych stron.",
        motivation:
          "Motywuje Cię praca nad konkretnymi i namacalnymi projektami niż abstrakcyjnymi.",
        boss: "Szukasz liderów wyznaczających Ci jasnych zadań oraz wymagań jednocześnie pozwalając decydować ci o procesie ich wykonania.",
      },
      {
        top1: "Rozumiesz budowę i działanie obiektów, łatwo naprawiasz i tworzysz przedmioty.",
        top2: "Łatwo stosujesz schematy w praktyce i wyobrażasz sobie obiekty w 3D.",
        top3: "Myślisz logicznie i metodycznie rozwiązujesz problemy analizując wszystkie fakty.",
        demotivation:
          "Niejasne zasady i brak standardów ograniczają Twoją skuteczność.",
        motivation:
          "Wolisz pracować nad konkretnymi, namacalnymi projektami niż abstrakcją.",
        boss: "Potrzebujesz lidera, który jasno określa zadania i daje swobodę w ich realizacji.",
      },
      {
        top1: "Zainteresowanie tym, jak działają rzeczy, pozwala Ci je naprawiać i tworzyć nowe.",
        top2: "Łatwo wdrażasz schematy i potrafisz wyobrazić sobie projekt w trzech wymiarach.",
        top3: "Rozwiązujesz problemy w sposób logiczny i systematyczny, analizując wszystkie dane.",
        demotivation:
          "Chaotyczne środowisko i brak precyzji utrudniają Ci wykorzystanie talentu.",
        motivation:
          "Satysfakcjonuje Cię praca przy konkretnych, praktycznych projektach.",
        boss: "Szukasz szefa, który daje jasne wytyczne i pozwala decydować o metodach pracy.",
      },
      {
        top1: "Masz zdolność do naprawiania i wytwarzania przedmiotów dzięki znajomości zasad ich działania.",
        top2: "Schematy przyswajasz szybko i potrafisz wizualizować przestrzennie obiekty.",
        top3: "Myślisz metodycznie, rozwiązując problemy logicznie i w oparciu o fakty.",
        demotivation:
          "Brak jasnych zasad i standardów ogranicza Twoją efektywność.",
        motivation:
          "Najbardziej czerpiesz satysfakcję z konkretnych projektów, które można dotknąć.",
        boss: "Preferujesz lidera, który jasno definiuje zadania, ale nie narzuca sposobu wykonania.",
      },
      {
        top1: "Praktycznie wykorzystujesz wiedzę o budowie i działaniu przedmiotów.",
        top2: "Łatwo wdrażasz instrukcje i potrafisz wyobrazić sobie ich zastosowanie w przestrzeni.",
        top3: "Analizujesz fakty i rozwiązujesz problemy krok po kroku, logicznie.",
        demotivation:
          "Niejasne reguły i brak jakości ograniczają Twoje możliwości.",
        motivation:
          "Realizacja konkretnych projektów daje Ci największą satysfakcję.",
        boss: "Chcesz jasnych wymagań i przyzwolenia na własne decyzje w procesie pracy.",
      },
      {
        top1: "Twoja ciekawość tego, jak działają rzeczy, umożliwia Ci tworzenie i naprawianie obiektów.",
        top2: "Szybko uczysz się schematów i łatwo wizualizujesz projekty w 3D.",
        top3: "Metodycznie podchodzisz do problemów, analizując wszystkie możliwe rozwiązania.",
        demotivation:
          "Brak orientacji w pracy i niedbałość o jakość ograniczają Twój potencjał.",
        motivation: "Lubisz widzieć namacalne efekty swoich działań.",
        boss: "Oczekujesz lidera, który jasno określa cele, ale pozwala Ci wybrać drogę ich realizacji.",
      },
      {
        top1: "Łatwo wchodzisz w praktyczne działanie, rozumiesz budowę i funkcjonowanie przedmiotów.",
        top2: "Potrafisz stosować schematy i wyobrazić sobie przedmioty w przestrzeni.",
        top3: "Rozwiązujesz problemy logicznie i metodycznie, opierając się na faktach.",
        demotivation:
          "Nieprecyzyjne zasady i brak orientacji na jakość ograniczają Twoją skuteczność.",
        motivation:
          "Praca nad konkretnymi projektami daje Ci satysfakcję i poczucie sprawczości.",
        boss: "Szukasz lidera, który jasno wyznacza cele, a jednocześnie daje swobodę w realizacji zadań.",
      },
    ],
    desc: "umiejętność dostrzegania i implementowania schematów",
    cv_entry:
      "Opracowałem architekturę przepływu informacji w aplikacji Jobbli w oparciu o założenia zespołu produktowego",
  },
  artistic: {
    strong_suit: "Kreatywny",
    variants: [
      {
        top1: "Łatwo odnajdujesz się w dynamicznie zmieniającym się otoczeniu.",
        top2: "Potrafisz nieszablonowo postrzegać napotykane problemy i wysnuwać wnioski oparte na wcześniej niedostrzeżonych zależnościach.",
        top3: "Wyróżniasz się zdolnościami twórczymi oraz wysoko rozwiniętą wyobraźnią.",
        demotivation:
          "Ustrukturyzowany styl pracy, odtwórcze zadania bazujące na schematach ograniczają Twoje możliwości wykazania swoich mocnych stron.",
        motivation:
          "Motywuje Cię niezależność w wykonywaniu danych zadań, różnorodność projektów oraz możliwość wyrażania siebie poprzez swoją pracę.",
        boss: "Demotywują Cię wysoko kontrolujący szefowie oraz sztywne ramy i wymagania wykonywanej pracy.",
      },
      {
        top1: "Szybko odnajdujesz się w dynamicznie zmieniającym się środowisku.",
        top2: "Patrzysz na problemy nieszablonowo, dostrzegając zależności pomijane przez innych.",
        top3: "Wyróżnia Cię kreatywność i wysoko rozwinięta wyobraźnia.",
        demotivation:
          "Sztywne struktury i powtarzalne zadania ograniczają Twój potencjał.",
        motivation:
          "Niezależność, różnorodność projektów i możliwość wyrażania siebie w pracy.",
        boss: "Źle reagujesz na nadmierną kontrolę i narzucone, sztywne ramy działania.",
      },
      {
        top1: "Dobrze funkcjonujesz w zmiennym i dynamicznym otoczeniu.",
        top2: "Potrafisz tworzyć rozwiązania w oparciu o nietypowe skojarzenia i nowe perspektywy.",
        top3: "Twoją mocną stroną są zdolności twórcze i bogata wyobraźnia.",
        demotivation:
          "Praca oparta na schematach i odtwarzaniu gotowych rozwiązań.",
        motivation:
          "Swoboda działania, różnorodne zadania i przestrzeń na kreatywność.",
        boss: "Najlepiej pracujesz bez ciągłej kontroli i nadmiernych ograniczeń.",
      },
      {
        top1: "Z łatwością adaptujesz się do zmian i nowych warunków pracy.",
        top2: "Dostrzegasz zależności, które pozwalają Ci wyciągać oryginalne wnioski.",
        top3: "Posiadasz silnie rozwiniętą wyobraźnię i potencjał twórczy.",
        demotivation: "Sztywne procedury i mechaniczne wykonywanie zadań.",
        motivation:
          "Autonomia, różnorodność projektów i możliwość realizowania własnych pomysłów motywuje Cię.",
        boss: "Potrzebujesz lidera, który daje przestrzeń zamiast kontroli.",
      },
      {
        top1: "Sprawnie poruszasz się w środowiskach pełnych zmian.",
        top2: "Rozwiązujesz problemy w sposób twórczy, łącząc pozornie niepowiązane fakty.",
        top3: "Twoją siłą są kreatywność i wyobraźnia.",
        demotivation:
          "Nadmierna struktura i powtarzalność zadań wpływają na Ciebie negatywnie.",
        motivation:
          "Motywuje Cię swoboda działania i możliwość wyrażania siebie poprzez pracę.",
        boss: "Unikasz przełożonych, którzy narzucają sztywne zasady i kontrolują każdy krok.",
      },
      {
        top1: "Dobrze odnajdujesz się w środowisku, które często się zmienia.",
        top2: "Myślisz nieszablonowo i tworzysz rozwiązania oparte na nowych zależnościach.",
        top3: "Wyróżnia Cię twórcze podejście i rozwinięta wyobraźnia.",
        demotivation:
          "Praca oparta wyłącznie na schematach i odtwarzaniu demotywuje Cię.",
        motivation:
          "Motywują Cię różnorodne projekty, niezależność i możliwość kreatywnej ekspresji.",
        boss: "Najlepiej funkcjonujesz bez nadmiernej kontroli i sztywnych ram.",
      },
      {
        top1: "Z łatwością dostosowujesz się do dynamicznych zmian.",
        top2: "Potrafisz spojrzeć na problem z innej perspektywy i wyciągać nowe wnioski.",
        top3: "Twoją naturalną cechą są zdolności twórcze i silna wyobraźnia.",
        demotivation:
          "Odtwórcze zadania i zbyt uporządkowany styl pracy demotywują Cię.",
        motivation:
          "Autonomia, różnorodność i możliwość realizowania własnych pomysłów wpływa na Ciebie demotywująco.",
        boss: "Źle czujesz się przy przełożonych, którzy nadmiernie kontrolują sposób pracy.",
      },
    ],
    desc: "umiejętność zauważania nietypowych zależności",
    cv_entry:
      "Zaprojektowałem kampanię mailingową dla nowej grupy docelowej, zwiekszając liczbę użytkowników o 15%.",
  },
  social: {
    strong_suit: "Społeczny",
    variants: [
      {
        top1: "Potrafisz przekonywująco się komunikować i budować długotrwałe relacje.",
        top2: "Łatwo dzielisz się wiedzą i potrafisz doradzić innym.",
        top3: "Rozumiesz i odpowiadasz na potrzeby innych, często nawet na te niezakomunikowane wprost.",
        demotivation:
          "Zgrany i pozytywnie motywujący się zespół jest dla Ciebie. jedną z najważniejszych wartości, gdy wybierasz miejsce pracy.",
        motivation: "Demotywuje Cię ciągła rywalizacja w miejscu pracy.",
        boss: "Chłodni, szorstcy szefowie są dla Ciebie największym hamulcem rozwoju.",
      },
      {
        top1: "Potrafisz przekonywająco komunikować się i budować trwałe relacje.",
        top2: "Łatwo dzielisz się wiedzą i doradzasz innym w potrzebie.",
        top3: "Rozumiesz i reagujesz na potrzeby innych, także te niewypowiedziane.",
        demotivation:
          "Ciągła rywalizacja w pracy obniża Twój poziom zaangażowania.",
        motivation:
          "Współpraca w zgranym, pozytywnie nastawionym zespole napędza Cię do działania.",
        boss: "Chłodni i szorstcy przełożeni ograniczają Twój rozwój.",
      },
      {
        top1: "Wyróżnia Cię umiejętność przekonywającej komunikacji i budowania relacji.",
        top2: "Chętnie dzielisz się wiedzą i wspierasz innych w rozwiązywaniu problemów.",
        top3: "Potrafisz dostrzegać potrzeby innych, nawet te niewypowiedziane.",
        demotivation:
          "Środowisko pracy pełne rywalizacji odbiera Ci motywację.",
        motivation:
          "Czujesz satysfakcję, gdy pracujesz w zgranym i wspierającym zespole.",
        boss: "Źle funkcjonujesz przy liderach szorstkich i nieprzystępnych.",
      },
      {
        top1: "Łatwo nawiązujesz relacje i potrafisz skutecznie przekonywać innych.",
        top2: "Potrafisz doradzać i dzielić się wiedzą w sposób przystępny dla innych.",
        top3: "Rozumiesz potrzeby ludzi i umiesz reagować, nawet gdy nie są wyrażone wprost.",
        demotivation:
          "Praca w ciągłej rywalizacji ogranicza Twój komfort i zaangażowanie.",
        motivation:
          "Zgrany zespół, który wspiera się nawzajem, jest dla Ciebie źródłem energii.",
        boss: "Najgorzej pracujesz z przełożonymi chłodnymi i zdystansowanymi.",
      },
      {
        top1: "Wyróżnia Cię zdolność przekonywania i budowania długotrwałych relacji.",
        top2: "Łatwo dzielisz się wiedzą i wspierasz współpracowników w trudnych sytuacjach.",
        top3: "Potrafisz dostrzegać i reagować na potrzeby innych, nawet jeśli nie są wyrażone wprost.",
        demotivation:
          "Ciągła rywalizacja w miejscu pracy odbiera Ci satysfakcję.",
        motivation:
          "Motywuje Cię współpraca w zgranym, pozytywnie nastawionym zespole.",
        boss: "Szorstki i nieprzystępny szef jest dla Ciebie hamulcem rozwoju.",
      },
      {
        top1: "Potrafisz skutecznie komunikować swoje pomysły i budować trwałe relacje.",
        top2: "Chętnie doradzasz innym i dzielisz się swoją wiedzą.",
        top3: "Rozumiesz potrzeby ludzi i reagujesz na nie, często zanim zostaną wyrażone.",
        demotivation:
          "Nadmierna rywalizacja w pracy ogranicza Twoją motywację.",
        motivation:
          "Zgrany i wspierający się zespół daje Ci energię do działania.",
        boss: "Źle pracujesz pod kierownictwem szorstkim i chłodnym.",
      },
      {
        top1: "Wyróżnia Cię umiejętność przekonywania i nawiązywania relacji.",
        top2: "Potrafisz dzielić się wiedzą i pomagać innym w rozwiązywaniu problemów.",
        top3: "Łatwo rozpoznajesz potrzeby innych i odpowiednio na nie reagujesz.",
        demotivation:
          "Ciągła rywalizacja w miejscu pracy obniża Twój potencjał.",
        motivation:
          "Motywuje Cię praca w zespole, który współpracuje i wspiera się nawzajem.",
        boss: "Najgorzej czujesz się przy liderach szorstkich i nieprzystępnych.",
      },
    ],
    desc: "umiejętność komunikacji i budowania relacji",
    cv_entry:
      "Zorganizowałem jako Przewodniczący Studenckiego Koła Innowacji 2 konferencje studenckie o AI, które pomogły 250 studentom zrozumieć wykorzystanie AI na rynku pracy.",
  },

  investigative: {
    strong_suit: "Innowacyjny",
    variants: [
      {
        top1: "Potrafisz sprawnie rozwiązywać złożone problemy.",
        top2: "Łatwo uczysz się obiektywnie skomplikowanych rzeczy nawet co zapewnia ci duża elastyczność w wyborze pracy i nauce nowych zawodów.",
        top3: "Twój sposób działania oparty jest na mierzalnych danych, co pozwala Ci dobrze argumentować swoje pozycje.",
        demotivation:
          "Potrzebujesz dużo przestrzeni i wolności w miejscu pracy, aby móc osiągać maksimum swojego potencjału i czuć się spełniony.",
        motivation:
          "Motywuje Cię mierzenie się z nowymi problemami, które nie zostały przez nikogo innego jeszcze rozwiązane.",
        boss: "Demotywują Cię wysoko kontrolujący szefowie.",
      },
      {
        top1: "Sprawnie analizujesz i rozwiązujesz złożone problemy wymagające nieszablonowego myślenia.",
        top2: "Szybko uczysz się trudnych zagadnień, co daje Ci dużą elastyczność w zmianie ról i zawodów.",
        top3: "Łączysz różne perspektywy i pomysły, tworząc nowe, oryginalne rozwiązania.",
        demotivation:
          "Ograniczenia, brak swobody i sztywne ramy pracy obniżają Twoje zaangażowanie.",
        motivation:
          "Najbardziej napędzają Cię nowe wyzwania i problemy, z którymi nikt wcześniej się nie mierzył.",
        boss: "Nadmiernie kontrolujący przełożeni skutecznie odbierają Ci motywację.",
      },
      {
        top1: "Skutecznie radzisz sobie z trudnymi i złożonymi problemami.",
        top2: "Łatwo przyswajasz skomplikowaną wiedzę, co pozwala Ci zmieniać kierunek rozwoju.",
        top3: "Myślisz nieszablonowo i szybko generujesz nowe pomysły.",
        demotivation: "Brak przestrzeni i autonomii ogranicza Twój potencjał.",
        motivation:
          "Najbardziej motywują Cię wyzwania bez gotowych odpowiedzi.",
        boss: "Źle odnajdujesz się przy silnie kontrolujących szefach.",
      },
      {
        top1: "Potrafisz szybko analizować i rozwiązywać złożone problemy.",
        top2: "Sprawnie uczysz się trudnych zagadnień, co daje Ci dużą elastyczność zawodową.",
        top3: "Dostrzegasz nowe możliwości tam, gdzie inni widzą bariery.",
        demotivation: "Sztywne ramy pracy ograniczają Twoją skuteczność.",
        motivation:
          "Motywuje Cię praca nad nowymi i nierozwiązanymi problemami.",
        boss: "Nadmierna kontrola ze strony przełożonego działa demotywująco.",
      },
      {
        top1: "Sprawnie porządkujesz i rozwiązujesz skomplikowane problemy.",
        top2: "Szybko uczysz się złożonych tematów, co ułatwia Ci zmianę zawodów.",
        top3: "Tworzysz innowacyjne rozwiązania, łącząc różne perspektywy.",
        demotivation:
          "Ograniczona swoboda działania obniża Twoje zaangażowanie.",
        motivation: "Motywują Cię wyzwania wymagające nowego podejścia.",
        boss: "Kontrolujący styl zarządzania odbiera Ci motywację.",
      },
      {
        top1: "Skutecznie rozwiązujesz złożone problemy wymagające analizy.",
        top2: "Łatwo uczysz się trudnych zagadnień, co daje Ci swobodę rozwoju.",
        top3: "Generujesz nowe koncepcje i niestandardowe rozwiązania.",
        demotivation: "Brak wolności w pracy ogranicza Twoje możliwości.",
        motivation:
          "Motywuje Cię mierzenie się z nowymi, nieodkrytymi problemami.",
        boss: "Wysoki poziom kontroli ze strony szefa działa na Ciebie demotywująco.",
      },
      {
        top1: "Potrafisz skutecznie rozwiązywać skomplikowane problemy o wysokim poziomie trudności.",
        top2: "Łatwo przyswajasz złożoną wiedzę, co pozwala Ci szybko zmieniać kierunek rozwoju zawodowego.",
        top3: "Myślisz przyszłościowo i proponujesz rozwiązania wyprzedzające schematy.",
        demotivation:
          "Ograniczona swoboda działania i brak przestrzeni do eksperymentowania.",
        motivation:
          "Motywują Cię wyzwania, które wymagają tworzenia zupełnie nowych rozwiązań.",
        boss: "Przełożeni nadmiernie ingerujący w Twoją pracę obniżają Twoją motywację.",
      },
    ],
    desc: "umiejętność nieszablonowego myślenia",
    cv_entry:
      "Opracowałem nowy system organizacji dokumentacji w firmie Jobbli, który skrócił czas raportowania o 12%.",
  },

  conventional: {
    strong_suit: "Metodyczny",
    variants: [
      {
        top1: "Wykazujesz się wysoką zdolnością przestrzennego myślenia.",
        top2: "Wyróżniasz się umiejętnością pracy z danymi (zarówno liczbowymi jak i tekstowymi) w oparciu o ustalone z góry procedury.",
        top3: "Jesteś precyzyjny i metodologiczne podchodzisz do rozwiązywania problemów, co pozwala Ci na dostrzeżenie detalicznych zależności.",
        demotivation:
          "Demotywuje Cię chaos, abstrakcja zadań i niezależność w ich wykonywaniu.",
        motivation:
          "Motywuje Cię ustruktyryzowana praca nastawiona na jakość niż na ilość.",
        boss: "Potrzebujesz regularnego nadzoru od strony Twojego szefa, który stworzy ci komfort pracy jasno komunikując swoje wymagania.",
      },
      {
        top1: "Myślisz przestrzennie i dobrze poruszasz się w uporządkowanych strukturach.",
        top2: "Sprawnie pracujesz z danymi liczbowymi i tekstowymi według ustalonych procedur.",
        top3: "Działasz precyzyjnie i metodycznie, dostrzegając zależności na poziomie detali.",
        demotivation:
          "Chaos, niejasność zadań i zbyt duża swoboda w sposobie ich realizacji utrudniają Ci skuteczną pracę.",
        motivation:
          "Ustrukturyzowana praca nastawiona na jakość, a nie ilość motywuje Cię.",
        boss: "Potrzebujesz przełożonego, który jasno komunikuje wymagania i zapewnia regularny nadzór.",
      },
      {
        top1: "Wykazujesz się wysoką zdolnością myślenia przestrzennego.",
        top2: "Pracujesz z danymi w oparciu o jasno określone procedury i zasady.",
        top3: "Rozwiązujesz problemy w sposób metodyczny, zwracając uwagę na szczegóły.",
        demotivation:
          "Demotywuje Cię brak struktury, abstrakcyjne zadania i konieczność pełnej samodzielności.",
        motivation:
          "Motywuje Cię praca oparta na standardach jakości i jasno określonych procesach.",
        boss: "Najlepiej funkcjonujesz z liderem, który regularnie monitoruje postępy i jasno stawia oczekiwania.",
      },
      {
        top1: "Dobrze odnajdujesz się w pracy wymagającej myślenia przestrzennego.",
        top2: "Przetwarzasz dane zgodnie z procedurami, dbając o spójność i poprawność.",
        top3: "Metodycznie analizujesz problemy, skupiając się na szczegółach.",
        demotivation:
          "Praca bez struktury, abstrakcyjne cele i brak jasnych wytycznych demotywują Cię.",
        motivation:
          "Motywuje Cię jasno uporządkowane zadania nastawione na wysoką jakość.",
        boss: "Najlepiej pracujesz z przełożonym, który regularnie nadzoruje proces i jasno określa wymagania.",
      },
      {
        top1: "Myślenie przestrzenne pozwala Ci skutecznie porządkować informacje.",
        top2: "Dobrze pracujesz z danymi, gdy obowiązują jasno określone procedury.",
        top3: "Wyróżnia Cię precyzja i metodyczne podejście do rozwiązywania problemów.",
        demotivation:
          "Chaos, brak struktury i nadmierna niezależność w pracy demotywuje Cię.",
        motivation:
          "Motywuje Cię praca oparta na jakości, standardach i uporządkowanych procesach.",
        boss: "Potrzebujesz lidera, który zapewnia jasne wytyczne i stałe wsparcie.",
      },
      {
        top1: "Posiadasz rozwiniętą zdolność przestrzennego myślenia.",
        top2: "Potrafisz analizować dane liczbowe i tekstowe według ustalonych schematów.",
        top3: "Pracujesz precyzyjnie i konsekwentnie, dostrzegając nawet drobne zależności.",
        demotivation: "Chaos organizacyjny, niejasność zadań i brak nadzoru.",
        motivation:
          "Uporządkowana praca skoncentrowana na jakości wykonania jej przez Ciebie.",
        boss: "Potrzebujesz przełożonego, który jasno komunikuje wymagania i zapewnia poczucie bezpieczeństwa.",
      },
      {
        top1: "Posiadasz wysoką zdolność myślenia przestrzennego.",
        top2: "Sprawnie analizujesz dane liczbowe i tekstowe w oparciu o ustalone procedury.",
        top3: "Działasz precyzyjnie i metodologicznie, dostrzegając szczegółowe zależności.",
        demotivation:
          "Nieuporządkowane środowisko pracy i brak jasno określonych zasad demotywują Cię.",
        motivation:
          "Ustrukturyzowana praca nastawiona na jakość wykonania motywują Cię.",
        boss: "Najlepiej funkcjonujesz z przełożonym, który jasno komunikuje wymagania i zapewnia regularny nadzór.",
      },
    ],
    desc: "umiejętność analitycznego podejścia do problemów",
    cv_entry:
      "Zidentyfikowalem i wyeliminowalem wiele zbędnych kroków w wewnętrznych procedurach zamówień firmy Jobbli, skracając czas realizacji procesu o 40%.",
  },
};

export default riasecVariants;
